<template>
    <div>
      <p class="ArticleNormal">
        城市形象既是城市本地文化特色的载体，又能够对于城市文化的传承、弘扬和创新起到引领作用。城市形象与城市竞争力密切相关，富有魅力的形象，不仅仅意味着城市本身对于人群的吸引力，同样对于城市品牌营销、文化创意、旅游产业的发展，有着重要的催化剂作用。繁荣的城市必然会展现出美好的形象，而美好的城市形象也会进一步促进城市更加繁荣。
      </p>
      <p class="ArticleNormal">
        莎士比亚的作品中有一句“城市即人”。城市的形象来自于人们的认知。几十年前，城市研究学者凯文•林奇，提出城市意象理论，首次从人的视角探讨了人们对城市空间点、线、面等要素的感知。如今，城市形象概念的内涵和外延不断拓展。城市形象的展示主体既可以是北京的三里屯，也可以是爆红抖音的李子坝这样的网红景点。城市形象告别了宏大、巨构的单一叙事时代，更加体现出个性、多元的特征。一种流行的生活场景，一些人个体的记忆，一段爆款的新闻，都可以塑造一种城市形象。
      </p>
      <img src="../../../assets/1st/Articles/Article_11/contant_1.jpg"/>
      <p class="ArticleNormal">
        如今，以信息通信、移动互联网等为驱动和载体的新技术，深刻的影响着我们的日常生活，重塑着人与人的交流方式，也潜移默化的改变了城市形象的传播和认知方式。人们对于城市的感知，从实体空间拓展到虚拟空间。从城市的发展趋势来看，数字孪生成为未来城市的一种形态。实体空间和网络空间深度耦合交织。新技术与新文化的驱动，正日新月异的重塑城市形象的内涵和形态。新媒体可以看作跨越虚拟和现实世界的信息传导，通过线上线下的互动创造着新的城市意象，并且进行着新的方式的传播。互联网对空间再生产的线上线下交融，创造了城市形象传播的新方式。
      </p>
      <p class="ArticleNormal">
        在抖音这款APP开始走红之后，许多城市与人一样，依托于抖音平台成为“网红”，广泛吸收网络流量，并导流于线下，促进了文旅产业的发展。典型的如成都、重庆和西安这样的城市，在抖音上成为了网红爆款。前两年，游客们在西安古城墙下永兴坊的摔碗酒的小视频，引爆了关于这座城市的流量。游客们买一碗酒，喝完后将碗摔向碎碗堆里，讨个岁岁平安的彩头。没想到这些视频在抖音平台大火。随后西安市高新区、西咸新区、曲江等区域都涌现出了各种爆款抖音视频。甚至城市官方也通过抖音平台，进行2018年的“西安年·最中国”的文化旅游宣传。很多人是因为抖音短视频的缘故，专门跑到西安旅游，人流进而带来了信息流和资本流的一种交互。这座向来以传统、厚重的历史文化闻名的古城，借助互联网文化生产，实现了更加新潮的城市影响传播。这座城市的网红形象也因此深入人心。
      </p>
      <p class="ArticleNormal">
        一种以网络视频为触媒，文化旅游和创意产业跟进的线上线下互动的模式，成为城市形象传播的新趋势。这可谓是“数字孪生城市”的一种体现：城市在现实世界中展开抢人大战，通过各种政策、机制来吸引居民安居落户、吸引游客游玩消费。在网络世界，城市则如同一个个网红主播一样，在媒体平台上展开竞争，竞相引流圈粉。以短视频为代表的新媒体，在虚拟和现实之间打通的闭环信息流，实际上重塑了虚拟和现实的形象关联。抖音的地域性视频，表达了网友们对于有趣、充满活力、时尚以及国际化的城市元素的认可。这与理查德·佛罗里达的创意阶层理论不谋而合，可以看作是新时期人们对于理想城市的理解：城市不仅需要有良好的基础设施，更要有多元、开放和富有创意的社会氛围。新媒体在虚拟世界构建出的城市新形象，通过线上线下的互动，把城市的各种要素进行“内容生产”和大众传播。
      </p>
      <img src="../../../assets/1st/Articles/Article_11/contant_2.jpg"/>
      <p class="ArticleNormal">
        同时，线上的城市文化也在影响着线下空间的更新和改造，城市的景观、街道、建筑等形成了多维度的场景，场景体现了一座城市整体文化风格和美学特征，城市场景的塑造愈发收到线上网络文化的影响，趋向于网红化和个性化，试图赋予城市形象更鲜明的特征与价值。例如现在随处可见的文化市集、灯光秀、pop-up展览以及公共艺术装置等，都吸引着大量年轻人前来参观体验，并在线上通过文字、照片和视频进行分享，再带上城市或地点的定位，又会在互联网上吸引更多的年轻人前来打卡。一座城市的魅力，正是来自于这些不断焕发青春活力的城市形象，也一定程度上决定了城市是否繁荣的未来。
      </p>
      <p class="ArticleNormal">
        可以展望未来，在虚拟与现实高度混合的城市中，现实世界的公民——同时也是虚拟世界的网民，把个人的、私密的、情绪化的表达通过网络导入城市空间，最终造成了这种现实与数字混合空间的城市认知和心理感受。我们有必要从人的角度，从日常生活中去理解空间的复杂的变革历程，从文化心理去认知互联网原住民们心中的城市形象。因此，我们需要深刻地理解信息时代城市的时空演变，动态把握变化发展的城市形象，并从更多的维度评估城市。
      </p>
      <p class="ArticleNormal">
        新时期，以人为本的城市发展观，对于城市的品质、活力、人文魅力提出了新的要求。以往的城市形象的形成，更多是基于其物理特征——如城市肌理、建筑群体、景观风貌、色彩等。而如今的文化地标，越来越突出其大众文化的心理属性，强调人们对于城市空间要素的主观感知和心理感受。在信息技术渗入日常生活的过程中，我们的大众文化、社交方式、城市生活不断变化。记录我们生活的数字内容正在更大尺度上为城市构建一种数字图景。这个过程已经不可阻挡地在发生。并且这种演变的速度和规模，远超我们基于固有知识的想象。将我们对于城市的评估从线下拓展到线上，通过以新媒体为代表的内容来思考人们在现实和数字世界交互中对城市的全新认知，对于在新时期探索理想城市的建设，意义重大。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article11"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article11.vue